// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3d6bba61","957":"057e3b8a"}[chunkId] + ".chunk.js";
};